import ActiveExpeditionsSelectors from "./Components/ActiveExpeditionsSelectors";
import AwbHistoryTable from "./AwbHistoryTable";
import BinHistoryTable from "./BinHistoryTable";
import useActiveExpeditions from "./useActiveExpeditions";

function ActiveExpeditions() {
  const { type, view, clientsNodes, handleChangeView } = useActiveExpeditions();

  return (
    <>
      <ActiveExpeditionsSelectors
        type={type}
        view={view}
        onChange={handleChangeView}
      />
      {view === "awb" ? (
        <AwbHistoryTable key={`${type}-awb`} clientsNodesData={clientsNodes} />
      ) : (
        <BinHistoryTable key={`${type}-bin`} clientsNodesData={clientsNodes} />
      )}
    </>
  );
}

export default ActiveExpeditions;
